import styled from "styled-components";
interface TextInputProps {
  color: string;
}
export const Divider = styled.hr`
  border: 1.5px solid #fff;
  margin-bottom: var(--sp-10);
`;
export const Title = styled.h1`
  display: flex;
  align-self: center;
  justify-content: center;
  justify-self: center;
  align-items: center;
  align-content: center;
  font-size: var(--fs-2xl);
  font-family: "Roboto", sans-serif;
  color: #fff;
  margin-bottom: var(--sp-10);
`;
export const SubTitle = styled.h2`
  display: flex;
  align-self: center;
  justify-content: center;
  justify-self: center;
  align-items: center;
  align-content: center;
  font-size: var(--fs-lg);
  font-family: "Roboto", sans-serif;
  color: #fff;
  margin-bottom: calc(var(--u) * 30);
`;
export const AccordionContainer = styled.div``;
export const AccordionInner = styled.div`
  position: relative;
  width: 100%;
  border: 1px solid black;
  border-radius: 4px;
`;
export const AccordionItem = styled.div`
  &:not(:last-child) {
    border-bottom: 1px solid black;
  }
`;
export const AccordionTitle = styled.h3`
  justify-content: left;
  width: 100%;
  display: flex;
  background-color: #00000090;
  color: #fff;
  font-weight: 500;
  font-size: calc(var(--u) * 19.2);
  margin: 0;
  padding: var(--sp-16);
  cursor: pointer;
`;
export const AccordionBody = styled.div`
  display: block;
  position: relative;
  padding: 0;
  margin: 0;
  height: 0;
  overflow: hidden;
  transition: height 0.3s;
`;
export const AccordionContent = styled.p`
  margin-top: var(--sp-20);
  padding: 0 var(--sp-16) var(--sp-16);
  height: auto;
`;
export const EditorContainer = styled.div`
width: 7%;
height: 7%;
  position: fixed;
  bottom: 7%;
  right: 2%;
  z-index: 2;
  cursor: pointer;
  border-radius: 50%;
  //on houver we need to enable a shadow white border, with a 1s transition
  &:hover {
    box-shadow: 0px 0px 150px white;
  }
  transition: box-shadow 0.5s ease-in-out;
`;
export const MenuContainer = styled.div<{ open: boolean }>`
  position: fixed;
  top: 0;
  /* O painel esconde-se deslocando exatamente a própria largura: os dois 600
     têm que escalar junto, ou em 1920 uma faixa dele fica aparecendo fechado. */
  left: ${(props) => (props.open ? "0" : "calc(var(--u) * -600)")};
  width: calc(var(--u) * 600);
  height: 100%;
  background-color: #101117ed;
  transition: left 0.4s ease-in-out;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);
  overflow-y: auto;
  padding: calc(var(--u) * 50);
  z-index: 100;
`;
export const Button = styled.button<{ color: string }>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: calc(var(--u) * 40);
  height: calc(var(--u) * 40);
  background-color: #ffffff90;
  color: ${(props) => props.color};
  border: none;
  border-radius: 50%;
  cursor: pointer;
  &:hover {
    background-color: ${(props) => props.color};
    color: #ffffff;
  }
`;
export const CheckboxContainer = styled.div<{ backgroundColor?: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--sp-10);
`;
export const CheckboxLabel = styled.label`
  font-size: var(--fs-xs);
  position: relative;
  width: 3.5em;
  height: 2em;
`;
export const CheckboxInput = styled.input`
  opacity: 1;
  width: 0;
  height: 0;
  &.checked {
    transform: translateX(1.4em);
    background-color: #fff;
  }
`;
export const CheckboxSlider = styled.span<{ color: string }>`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #fff;
  border: 1px solid ${(props) => props.color};
  transition: 0.4s;
  border-radius: 30px;
  &.checked {
    background-color: ${(props) => props.color};
  }
`;
export const CheckboxThumb = styled.span`
  position: absolute;
  height: 1.4em;
  width: 1.4em;
  border-radius: 20px;
  left: 0.27em;
  bottom: 0.25em;
  background-color: #adb5bd;
  transition: 0.4s;
  &.checked {
    background-color: #ffffff;
    transform: translateX(1.4em);
  }
`;
export const GeneralContent = styled.div`
  display: flex;
  justify-content: right;
  flex-direction: column;
  margin-bottom: var(--sp-20);
`;
export const FlexRow = styled.div<{ padding: string }>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-bottom: ${(props) => props.padding};
`;
export const TextInput = styled.div<{ color: string }>`
  width: calc(var(--u) * 350);
  font-size: var(--fs-lg);
  position: relative;
  border: 1px solid ${(props) => props.color};
  border-radius: 6px;
  margin: var(--sp-10);
  input {
    width: 100%;
    font-size: calc(var(--u) * 19.2);
    padding: var(--sp-4) var(--sp-2) var(--sp-2) var(--sp-4);
    border: 1px solid #bbbbbb;
    border-radius: 5px;
    outline: unset;
    transition: outline 0.2s ease;
  }
  input:focus {
    box-shadow: 0 0 0 1px #e8e8e8, 0 0 0 3px ${(props) => props.color};
  }

  label {
    padding: 0 var(--sp-5);
    transition: all 0.1s ease-in-out;
    position: absolute;
    top: 50%;
    right: calc(var(--u) * 10);
    color: #000000;
    transform: translateY(-50%);
    pointer-events: none;
    background: #ffffff;
    border-radius: 5px;
  }

  input:focus ~ label,
  input:not(:placeholder-shown) ~ label {
    top: calc(var(--u) * 10);
    right: 0px;
    transform: scale(0.85) translateY(-120%);
    background: ${(props) => props.color};
    color: white;
  }
`;
export const MaterialIcon = styled.i<{
  fontSize: string;
  color?: string;
  backgroundColor?: string;
  padding?: string;
}>`
  display: flex;
  align-items: center;
  font-family: "Material Icons";
  font-weight: normal;
  font-style: normal;
  font-size: ${(props) => props.fontSize};
  color: ${(props) => props.color};
  background-color: ${(props) => props.backgroundColor};
  padding: ${(props) => props.padding};
`;
export const FieldContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-items: center;
  margin-bottom: var(--sp-10);
`;
export const ProportionSlider = styled.input<{
  color: string;
  value?: number;
  max?: number;
}>`
  -webkit-appearance: none;
  width: calc(var(--u) * 100);
  height: calc(var(--u) * 6);
  border-radius: 5px;
  outline: none;

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: calc(var(--u) * 16);
    height: calc(var(--u) * 16);
    border-radius: 50%;
    background: white;
    cursor: pointer;
    box-shadow: 0px 0px 5px rgba(66, 97, 255, 0.5);
    position: relative;
    top: calc(var(--u) * -5);
    z-index: 2;
  }

  &::-moz-range-thumb {
    width: calc(var(--u) * 16);
    height: calc(var(--u) * 16);
    border-radius: 50%;
    background: white;
    cursor: pointer;
    box-shadow: 0px 0px 5px rgba(66, 97, 255, 0.5);
    position: relative;
    z-index: 2;
  }

  &::-ms-thumb {
    width: calc(var(--u) * 16);
    height: calc(var(--u) * 16);
    border-radius: 50%;
    background: white;
    cursor: pointer;
    box-shadow: 0px 0px 5px rgba(66, 97, 255, 0.5);
    position: relative;
    z-index: 2;
  }

  &::-webkit-slider-runnable-track {
    width: 100%;
    height: calc(var(--u) * 6);
    background: ${(props) => {
    const value = props.value ?? 0;
    const max = props.max ?? 1;

    return `linear-gradient(to right, ${props.color}, ${(value * 100) / max
      }%, white ${(value * 100) / max}%, white)`;
  }};
    border-radius: 5px;
    border: none;
    position: relative;
    z-index: 1;
  }
`;
export const SwitchLabel = styled.label`
  font-size: var(--fs-base);
  position: relative;
  width: 3.5em;
  height: 2em;
`;

export const SwitchInput = styled.input`
  opacity: 1;
  width: 0;
  height: 0;
  &.checked {
    transform: translateX(1.4em);
    background-color: #fff;
  }
`;

export const Slider = styled.span<{ color: string }>`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #fff;
  border: 1px solid ${(props) => props.color};
  transition: 0.4s;
  border-radius: 30px;
  &.checked {
    background-color: ${(props) => props.color};
  }
`;

export const SliderThumb = styled.span`
  position: absolute;
  height: 1.4em;
  width: 1.4em;
  border-radius: 20px;
  left: 0.27em;
  bottom: 0.25em;
  background-color: #adb5bd;
  transition: 0.4s;
  &.checked {
    background-color: #ffffff;
    transform: translateX(1.4em);
  }
`;
export const DropdownInput = styled.div<{ color: string }>`
  width: calc(var(--u) * 350);
  font-size: var(--fs-lg);
  position: relative;
  border: 1px solid ${(props) => props.color};
  border-radius: 6px;
  margin: var(--sp-10);
  select {
    width: 100%;
    font-size: calc(var(--u) * 19.2);
    padding: var(--sp-4) var(--sp-2) var(--sp-2) var(--sp-4);
    border: 1px solid #bbbbbb;
    border-radius: 5px;
    outline: unset;
    transition: outline 0.2s ease;
  }

  select:focus {
    box-shadow: 0 0 0 1px #e8e8e8, 0 0 0 3px ${(props) => props.color};
  }

  label {
    padding: 0 var(--sp-5);
    transition: all 0.1s ease-in-out;
    position: absolute;
    top: 50%;
    right: calc(var(--u) * 10);
    transform: translateY(-50%);
    pointer-events: none;
    background: #ffffff;
    border-radius: 5px;
  }

  select:focus ~ label,
  select:not(:placeholder-shown) ~ label {
    top: calc(var(--u) * 10);
    right: 0px;
    transform: scale(0.85) translateY(-120%);
    background: ${(props) => props.color};
    color: white;
  }
`;
export const customStyles = {
  overlay: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "transparent",
    with: "100%",
    height: "100%",
  },
  content: {
    border: "none",
    background: "none",
    padding: "0",
  },
};
